import React, { Suspense, lazy } from 'react';
import { Route } from 'react-router-dom';
import Auth from '../../../../Layout/Auth';

import LoadingOverlay from 'react-loading-overlay';
import FadeLoader from 'react-spinners/FadeLoader';
LoadingOverlay.propTypes = undefined;

// Lazy load components for better performance
const StoreList = lazy(() => import('../Pages/StoreList'));
const StoreAdd = lazy(() => import('../Pages/StoreAdd'));
const StoreEdit = lazy(() => import('../Pages/StoreEdit'));
const StoreView = lazy(() => import('../Pages/StoreView'));
const StoreOperatingHours = lazy(() => import('../Pages/StoreOperatingHours'));

/**
 * Store module routes
 * @param {Object} props - Component props
 * @returns {JSX.Element} - Store routes
 */
const StoreRoute = (props) => {
  const { history } = props;
  
  return (
    <>
      {/* Store List Route */}
      <Route
        exact
        path="/:lng/settings/stores"
        render={() => (
          <Auth history={history} allowedRoles={['app_admin', 'admin', 'staff', 'agent']}>
            <Suspense fallback={<Loading />}>
              <StoreList history={history} />
            </Suspense>
          </Auth>
        )}
      />
      
      {/* Store Add Route */}
      <Route
        exact
        path="/:lng/settings/stores/add"
        render={() => (
          <Auth history={history} allowedRoles={['app_admin', 'admin', 'staff']}>
            <Suspense fallback={<Loading />}>
              <StoreAdd history={history} />
            </Suspense>
          </Auth>
        )}
      />
      
      {/* Store Edit Route */}
      <Route
        exact
        path="/:lng/settings/stores/edit/:slack"
        render={() => (
          <Auth history={history} allowedRoles={['app_admin', 'admin']}>
            <Suspense fallback={<Loading />}>
              <StoreEdit history={history} />
            </Suspense>
          </Auth>
        )}
      />
      
      {/* Store View Route */}
      <Route
        exact
        path="/:lng/settings/stores/view/:slack"
        render={() => (
          <Auth history={history} allowedRoles={['app_admin', 'admin', 'staff', 'agent']}>
            <Suspense fallback={<Loading />}>
              <StoreView history={history} />
            </Suspense>
          </Auth>
        )}
      />
      
      {/* Store Operating Hours Route */}
      <Route
        exact
        path="/:lng/settings/stores/operating-hours"
        render={() => (
          <Auth history={history} allowedRoles={['app_admin', 'admin', 'staff', 'agent']}>
            <Suspense fallback={<Loading />}>
              <StoreOperatingHours history={history} />
            </Suspense>
          </Auth>
        )}
      />
    </>
  );
};
function Loading() {
  return (
    <>
      <div className="wrapper">
        <span>Loading</span>
      </div>
    </>
  );
}
export default StoreRoute;
